export const GET_TICKETS = "SUPPORT:GET_TICKETS"
export const UPDATE_REQUEST_DESCRIPTION = "SUPPORT:UPDATE_REQUEST_DESCRIPTION"
export const RELOAD_TICKETS = "SUPPORT:RELOAD_TICKETS"
export const CREATE_TICKET = "SUPPORT:CREATE_TICKET"
export const DELETE_REQUEST = "SUPPORT:DELETE_REQUEST"
export const UPDATE_REQUEST = "SUPPORT:UPDATE_REQUEST"
export const UPLOAD_FILES = "SUPPORT:UPLOAD_FILES"
export const DELETE_FILE = "SUPPORT:DELETE_FILE"
